const EXAMPLE_HANDLES = ["@jane_smith", "@amanda_well"];

const exampleValueFor = (column: string, rowIndex: number): string =>
  column.toLowerCase().includes("handle")
    ? (EXAMPLE_HANDLES[rowIndex] ?? `@example${rowIndex + 1}`)
    : `Example ${rowIndex + 1}`;

export const WrongFileFormatTable = ({ columns }: { columns: string[] }) => (
  <div className="bg-[#fcf6f1] border border-border-secondary rounded-2xl px-4 pt-3 pb-4 flex flex-col gap-4 w-full">
    <p className="text-sm font-medium text-secondary">Expected CSV format.</p>
    <div className="border border-border-secondary rounded-md overflow-hidden bg-white">
      <div className="flex h-8 bg-secondary border-b border-border-secondary">
        {columns.map((column) => (
          <div key={column} className="flex-1 min-w-0 flex items-center px-2">
            <span className="text-sm font-medium text-secondary truncate">{column}</span>
          </div>
        ))}
      </div>
      {[0, 1].map((rowIndex) => (
        <div key={rowIndex} className="flex h-8 border-b border-border-secondary last:border-b-0">
          {columns.map((column) => (
            <div key={column} className="flex-1 min-w-0 flex items-center px-2">
              <span className="text-sm text-primary truncate">{exampleValueFor(column, rowIndex)}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);
